import React from 'react';
import * as ActionTypes from '../../../constants/ActionTypes';
import { handleActions } from 'redux-actions';

const manageSectionDataStoreDefaults = {
    themes: [
        {
            name: 'Kimpton 1',
            code: 'KIM1',
            updated: '2015-09-18T15:30:00.000Z',
            status: true,
            isDefault: true,
            type: 'theme'
        },
        {
            name: 'Summer Promo',
            code: 'SUMM',
            updated: '2014-09-18T15:30:00.000Z',
            status: false,
            isDefault: false,
            type: 'theme'
        }
    ],
    configurations: [
        {
            name: 'Standard',
            code: 'STD1',
            updated: '2015-09-18T15:30:00.000Z',
            status: true,
            isDefault: true,
            type: 'config'
        },
        {
            name: 'Minimal Version',
            code: 'MIN1',
            updated: '2014-09-18T15:30:00.000Z',
            status: false,
            isDefault: false,
            type: 'config'
        }
    ]
};

const manageSectionDataReducer = handleActions(
    {
        [ActionTypes.MANAGE_THEME_ADD_THEME]: (state, action) => ({
            ...state,
            themes: [...state.themes, action.theme]
        }),
        [ActionTypes.MANAGE_CONFIG_ADD_CONFIG]: (state, action) => ({
            ...state,
            configurations: [...state.configurations, action.configuration]
        }),
        [ActionTypes.MANAGE_THEME_MODAL_SET_THEME_LEVEL]: (state, action) => ({
            ...state,
            themelevel: action.themelevel
        }),
        [ActionTypes.MANAGE_THEME_SET_THEME_STATUS]: (state, action) => {
            let themeIndex = state.themes.indexOf(action.theme);
            if (themeIndex < 0) return state;
            let nextThemes = [
                ...state.themes.slice(0, themeIndex),
                { ...state.themes[themeIndex], status: action.status },
                ...state.themes.slice(themeIndex + 1)
            ];
            return { ...state, themes: nextThemes };
        },
        [ActionTypes.MANAGE_DELETE_ITEM]: (state, action) => {
            let nextItems = (arr, item) => {
                let idx = arr.indexOf(item);
                return [...arr.slice(0, idx), ...arr.slice(idx + 1)];
            };
            switch (action.item.type) {
                case 'theme':
                    return { ...state, themes: nextItems(state.themes, action.item) };
                case 'config':
                    return { ...state, configurations: nextItems(state.configurations, action.item) };
                default:
                    return state;
            }
        },
        [ActionTypes.MANAGE_SET_DEFAULT_THEME]: (state, action) => {
            switch (action.item.type) {
                case 'theme':
                    return {
                        ...state,
                        themes: state.themes.map(theme => {
                            if (theme.code === action.item.code) {
                                return { ...theme, isDefault: true, status: true };
                            } else return { ...theme, isDefault: false };
                        })
                    };
                case 'config':
                    return {
                        ...state,
                        configurations: state.configurations.map(config => {
                            if (config.code === action.item.code) {
                                return { ...config, isDefault: true, status: true };
                            } else return { ...config, isDefault: false };
                        })
                    };
            }
        }
    },
    manageSectionDataStoreDefaults
);

export default manageSectionDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/manage/data/manage.js